import { render, staticRenderFns } from "./unitSetting.vue?vue&type=template&id=942fa18e&scoped=true&"
import script from "./unitSetting.vue?vue&type=script&lang=js&"
export * from "./unitSetting.vue?vue&type=script&lang=js&"
import style0 from "./unitSetting.vue?vue&type=style&index=0&id=942fa18e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942fa18e",
  null
  
)

export default component.exports